import React from 'react';
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';

import { TopMenuLink } from '../../atoms/top-menu-link/top-menu-link';
import { flex } from '../../style-utils';

export type TopMenuItem = {
  name: string;
  onPress: () => void;
  containerStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  hoveredTextStyle?: StyleProp<TextStyle>;
};

export interface TopMenuProps {
  items: TopMenuItem[];
}

export function TopMenu({ items }: TopMenuProps) {
  return (
    <View style={[flex('flex-1', 'flex-row')]}>
      {items.map((item) => (
        <TopMenuLink key={item.name} {...item} />
      ))}
    </View>
  );
}
